import { types } from 'mobx-state-tree';

const BillingDetails = types.model({
  transactions: types.maybeNull(types.array(types.frozen())),
  refundTransactions: types.maybeNull(types.array(types.frozen())),
  nextPaymentDate: types.maybeNull(types.string),
  nextPaymentAmount: types.maybeNull(types.number),
  nextPaymentTransactionFee: types.maybeNull(types.number),
  nextPaymentTotal: types.maybeNull(types.number),
  // #37417: GO's already-billed open item (the agent's amount due now) / a term billed on GO's schedule.
  nextPaymentBilled: types.maybeNull(types.boolean),
  nextPaymentDueDate: types.maybeNull(types.string),
  legacyImportedTerm: types.maybeNull(types.boolean),
  nextPayments: types.optional(types.array(types.frozen()), []),
  totalInstallments: types.maybeNull(types.number),
  totalDue: types.maybeNull(types.number),
  totalRemaining: types.maybeNull(types.number),
  remainingPayments: types.maybeNull(types.number),
  activePaymentMethod: types.maybeNull(types.frozen()),
  allPaymentMethods: types.optional(types.array(types.frozen()), []),
  renewalPaymentDate: types.maybeNull(types.string)
});

export default BillingDetails;
